import { render } from "./Nav.vue?vue&type=template&id=b53beaa0&scoped=true"
import script from "./Nav.vue?vue&type=script&lang=js"
export * from "./Nav.vue?vue&type=script&lang=js"

import "./Nav.vue?vue&type=style&index=0&id=b53beaa0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53beaa0"]])

export default __exports__